import React, { useState, useEffect } from "react"
import {
    Box,
    Modal,
    Typography,
    Button,
} from "@mui/material"
import CInput from "../../../components/CInput"

export default function WorkerModal({ open, onClose, worker, onSave }) {
    const isEdit = Boolean(worker) // ✅ determines mode
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        nationalId: "",
        nationality: "",
        speciality: "",
    })

    // ✅ Prefill form if editing, otherwise reset
    useEffect(() => {
        if (worker) setForm(worker)
        else
            setForm({
                firstName: "",
                lastName: "",
                phoneNumber: "",
                nationalId: "",
                nationality: "",
                speciality: "",
            })
    }, [worker, open])

    const handleChange = (e) => {
        const { name, value } = e.target
        setForm((prev) => ({ ...prev, [name]: value }))
    }

    const handleSave = () => {
        onSave(form)
        onClose()
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #E4E7EC",
                    width: "460px",
                    p: 4,
                    boxShadow: "0px 8px 24px rgba(0,0,0,0.1)",
                }}
            >
                {/* Title */}
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: "20px",
                        color: "#101828",
                        mb: 3,
                    }}
                >
                    {isEdit ? "Edit Worker" : "Add Worker"}
                </Typography>

                {/* Form */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    <CInput
                        label="First Name"
                        name="firstName"
                        value={form.firstName}
                        onChange={handleChange}
                        placeholder="Enter first name"
                        required
                    />

                    <CInput
                        label="Last Name"
                        name="lastName"
                        value={form.lastName}
                        onChange={handleChange}
                        placeholder="Enter last name"
                        required
                    />

                    <CInput
                        label="Phone Number"
                        name="phoneNumber"
                        value={form.phoneNumber}
                        onChange={handleChange}
                        placeholder="Enter phone number"
                        required
                    />

                    <CInput
                        label="National ID"
                        name="nationalId"
                        value={form.nationalId}
                        onChange={handleChange}
                        placeholder="Enter national ID"
                        required
                    />

                    <CInput
                        label="Nationality"
                        name="nationality"
                        value={form.nationality}
                        onChange={handleChange}
                        placeholder="Enter nationality"
                        required
                    />

                    <CInput
                        label="Speciality"
                        name="speciality"
                        value={form.speciality}
                        onChange={handleChange}
                        placeholder="Enter speciality"
                        required
                    />
                </Box>

                {/* Action Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1.5,
                        mt: 4,
                    }}
                >
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            textTransform: "none",
                            borderColor: "#E4E7EC",
                            color: "#344054",
                            "&:hover": { borderColor: "#D0D5DD" },
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={{
                            backgroundColor: "#4D6BF6",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": { backgroundColor: "#3D5BD6" },
                        }}
                    >
                        {isEdit ? "Update Worker" : "Add Worker"}
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}
